import * as React from "react";
import "./index.css";
import {
  SubmitProgressIndicator,
  Cart,
  Checkout,
  SubmitInformationForm,
} from "../../components";
import { useGetCategoriesQuery } from "../../features/supabase/usecase/categories";
import { useGetFacilitiesQuery } from "../../features/supabase/usecase/facilities";
import { useGetAmenitiesQuery } from "../../features/supabase/usecase/amenities";
import {
  useGetSingleUserQuery,
  useLazyGetSingleUserQuery,
} from "../../features/supabase/usecase/users";
import {
  useCreateClassifiedMutation,
  useLazyGetClassifiedQuery,
  useUpdateClassifiedMutation,
} from "../../features/supabase/usecase/classifieds";
import storageService from "../../app/services/storageService";
import { toast } from "react-toastify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { selectAuth } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { ArrowBackIcon } from "../../components/icons";

const SubmitClassified = () => {
  const [progress, setProgress] = React.useState(0);

  const [formState, setFormState] = React.useState();

  const [cartState, setCartState] = React.useState();

  const [selectedAmenities, setSelectedAmenities] = React.useState({});
  const [selectedFacilities, setSelectedFacilities] = React.useState({});

  const [additionalPictures, setAdditionalPictures] = React.useState(0);

  const [files, setFiles] = React.useState([]);

  const user = useSelector(selectAuth);

  const [params, setParams] = useSearchParams();

  const [getDrafts, result] = useLazyGetClassifiedQuery();

  const [oldClassified, setClassified] = React.useState();

  React.useEffect(() => {
    if (result.isSuccess) {
      setFormState({
        ...result.data,
        ...(result?.data?.properties ?? {}),
      });
      setClassified(result.data);
      if (result.data?.amenities) {
        var amenities = {};
        result.data?.amenities.forEach((e) => {
          amenities[e.amenity.id] = true;
        });
        setSelectedAmenities(amenities);
      }
      if (result.data?.facilities) {
        var facilities = {};
        result.data?.facilities.forEach((e) => {
          facilities[e.facility.id] = e.quantity;
        });
        setSelectedFacilities(facilities);
      }
      setFiles(
        (result?.data?.properties?.images ?? []).map((e, i) => {
          return { path: e.toString() };
        })
      );
    }
  }, [result]);

  const id = params.get("edit");

  React.useEffect(() => {
    if (params.get("edit")) {
      getDrafts(parseInt(params.get("edit")));
    }
  }, [params.get("edit")]);

  const { data: categories, error, isLoading } = useGetCategoriesQuery();
  const {
    data: facilities,
    error: facilitiesError,
    isLoading: facilitiesLoading,
  } = useGetFacilitiesQuery();
  const {
    data: amenities,
    error: amenitiesError,
    isLoading: amenitiesLoading,
  } = useGetAmenitiesQuery();

  const navigate = useNavigate();

  const [isDisabled, setIsDisabled] = React.useState(false);

  const [createClassified, classifiedResult] = useCreateClassifiedMutation();

  const [updateClassified, updateClassifiedResult] =
    useUpdateClassifiedMutation();

  const [userState, setUserState] = React.useState();

  const [getUserState] = useLazyGetSingleUserQuery();

  React.useEffect(() => {
    if (user.user) {
      getUserState(user.user.id).then(({ data }) => {
        setUserState(data);
      });
    }
  }, [user.user]);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [progress]);

  const toastId = React.useRef(null);

  const clickOnLogin = () => {
    const button = document.querySelector("#profile-icon");
    button.click();
  };

  // React.useEffect(() => {
  //   if (params.get("page")) {
  //     setProgress(parseInt(params.get("page")));
  //   } else {
  //     setProgress(0);
  //   }
  // }, [params.get("page")]);

  function onInformationSubmit({
    state,
    files,
    selectedAmenities,
    selectedFacilities,
    additionalPictures,
  }) {
    setFormState(state);
    setFiles(files);
    setSelectedAmenities(selectedAmenities);
    setSelectedFacilities(selectedFacilities);
    setProgress(1);
    setAdditionalPictures(additionalPictures);
    // change the url to reflect the current state
    // const params = new URLSearchParams();
    // params.set("page", "1");
    // if (state.id)
    //   params.set("edit", state.id);
    // navigate({ search: params.toString() });
  }

  async function onSubmit() {
    const toastId = toast.loading("Classified is being submitted...", {
      autoClose: false,
      closeButton: false,
    });
    setIsDisabled(true);
    const result = [];
    console.log(files);
    for (const file of files) {
      if (file.file && file.path) {
        await storageService.update(file.file, file.path);
        result.push(file.path);
      } else if (file.file) {
        var { path } = await storageService.upload(file.file);
        result.push(path);
      } else {
        result.push(file.path);
      }
    }

    console.log(result);
    let classified = {
      id: formState.id,
      category_id: formState.category_id,
      title: formState.title,
      description: formState.description,
      email: formState.email,
      location_id: formState.location_id,
      status:
        userState?.allow_free || parseFloat(cartState?.finalAmount ?? 0) === 0
          ? userState?.is_pre_approved
            ? "approved"
            : "pending"
          : "processing",
      phone: formState.phone,
      whatsapp: formState.whatsapp,
    };

    let classifiedProperties = {
      ...(oldClassified?.properties ?? {}),
      street_address: formState.street_address,
      location_sqft: formState.location_sqft,
      price: formState.price,
      price_type: formState.price_type,
      newly_renovated: formState.newly_renovated,
      images: result,
      min_nights: formState.min_nights,
      salary: formState.salary,
      address_fields: formState.address_fields,
    };

    // remove null fields from classifiedProperties
    classifiedProperties = Object.fromEntries(
      Object.entries(classifiedProperties).filter(([_, v]) => v !== null)
    );

    const amenities = Object.keys(selectedAmenities).map((k) => parseInt(k));
    const facilities = Object.entries(selectedFacilities).map(([k, v]) => ({
      id: parseInt(k),
      quantity: parseInt(v),
    }));

    localStorage.removeItem("classified");
    localStorage.removeItem("amenities");
    localStorage.removeItem("facilities");
    localStorage.removeItem("duration");

    if (classified.id) {
      const classifiedData = await updateClassified({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      });

      if (classifiedData.error) {
        toast.dismiss(toastId);
        toast.update(toastId, {
          render:
            classifiedData?.error?.message || "Failed to submit classified",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
        setIsDisabled(false);
      }

      toast.update(toastId, {
        render: "Classified submitted successfully",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      });
      return classifiedData.data;
    } else {
      const classifiedData = await createClassified({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      });

      if (classifiedData.error) {
        toast.dismiss(toastId);
        toast.update(toastId, {
          render:
            classifiedData?.error?.message || "Failed to submit classified",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
        setIsDisabled(false);
      }

      toast.update(toastId, {
        render: "Classified submitted successfully",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      });

      return classifiedData.data;
    }
  }

  async function onSubmitDraft({
    state,
    files,
    selectedAmenities,
    selectedFacilities,
  }) {
    const toastId = toast.loading("Classified is being submitted...", {
      autoClose: false,
      closeButton: false,
    });
    setIsDisabled(true);
    const result = [];
    for (const file of files) {
      if (result.length === 5) {
        break;
      }
      if (file.file && file.path) {
        await storageService.update(file.file, file.path);
        result.push(file.path);
      } else if (file.file) {
        var { path } = await storageService.upload(file.file);
        result.push(path);
      } else {
        result.push(file.path);
      }
    }
    let classified = {
      id: state.id,
      category_id: state.category_id,
      title: state.title,
      description: state.description,
      email: state.email,
      location_id: state.location_id,
      phone: state.phone,
      whatsapp: state.whatsapp,
      status: "draft",
    };

    let classifiedProperties = {
      ...(oldClassified?.properties ?? {}),
      street_address: state.street_address,
      location_sqft: state.location_sqft,
      price: state.price,
      price_type: state.price_type,
      newly_renovated: state.newly_renovated,
      min_nights: state.min_nights,
      ...(result.length > 0 ? { images: result } : {}),
      salary: state.salary,
      address_fields: state.address_fields,
    };

    // remove null fields from classifiedProperties
    classifiedProperties = Object.fromEntries(
      Object.entries(classifiedProperties ?? {}).filter(([_, v]) => v !== null)
    );

    const amenities = Object.keys(selectedAmenities)
      .filter((k) => selectedAmenities[k])
      .map((k) => parseInt(k));
    const facilities = Object.entries(selectedFacilities).map(([k, v]) => ({
      id: parseInt(k),
      quantity: parseInt(v),
    }));

    localStorage.removeItem("classified");
    localStorage.removeItem("facilities");
    localStorage.removeItem("amenities");
    if (classified.id) {
      const classifiedData = await updateClassified({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      });
      if (classifiedData.error) {
        toast.dismiss(toastId);
        toast.update(toastId, {
          render:
            classifiedData?.error?.message || "Failed to submit classified",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
        setIsDisabled(false);
      }
    } else {
      const classifiedData = await createClassified({
        classified,
        classifiedProperties,
        amenities,
        facilities,
      });
      if (classifiedData.error) {
        toast.dismiss(toastId);
        toast.update(toastId, {
          render:
            classifiedData?.error?.message || "Failed to submit classified",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
        setIsDisabled(false);
      }
    }
    toast.dismiss(toastId);
    navigate("/dashboard?tab=draft");
  }

  const [mainProgress, setMainProgress] = React.useState(0);

  React.useEffect(() => {
    if (mainProgress <= progress) {
      setMainProgress(progress);
    }
  }, [progress]);

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="submit-classified-base">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          paddingTop: "120px",
        }}
      >
        <div className="categories-action-buttons">
          <button className="back-button" onClick={handleBack}>
            <ArrowBackIcon size={19} fill={"black"} />
            <div>Back</div>
          </button>
        </div>
        <span className="submit-classified-header">Submit a Classified</span>
      </div>
      <SubmitProgressIndicator
        progress={progress}
        setProgress={(progress) => {
          setProgress(progress);
          // const params = new URLSearchParams();
          // params.set("page", progress);
          // if (id)
          //   params.set("edit", id);
          // navigate({ search: params.toString() });
        }}
      />
      {isLoading || amenitiesLoading || facilitiesLoading ? (
        <div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="skeleton submit-skeleton-input"></div>
          <div className="submit-skeleton-row">
            <div className="skeleton submit-skeleton-button"></div>
            <div className="skeleton submit-skeleton-button"></div>
          </div>
        </div>
      ) : (
        <div className="submit-classified-content">
          {progress === 0 ? (
            <SubmitInformationForm
              key={formState?.id ?? ""}
              formState={formState}
              onComplete={onInformationSubmit}
              categories={categories}
              facilities={facilities}
              amenities={amenities}
              formAdditionalPictures={additionalPictures}
              formAmenities={selectedAmenities}
              formFacilities={selectedFacilities}
              formFiles={files}
              onDraftSave={onSubmitDraft}
            />
          ) : progress === 1 ? (
            <Cart
              onBack={() => {
                // const params = new URLSearchParams();
                // params.set("page", "0");
                // if (id)
                //   params.set("edit", id);
                // navigate({ search: params.toString() });
                setProgress(0);
              }}
              data={{
                title:
                  categories.find(
                    (category) => category.id === formState.category_id
                  ).name +
                  " " +
                  "Classified",
                category_id: formState.category_id,
                price: categories.find(
                  (category) => category.id === formState.category_id
                ).price,
                ...cartState,
                additionalPictures: additionalPictures,
              }}
              onProceedToCheckout={(data) => {
                setCartState(data);
                if (!user.user) {
                  return clickOnLogin();
                }
                // const params = new URLSearchParams();
                // params.set("page", "2");
                // if (id)
                //   params.set("edit", id);
                // navigate({ search: params.toString() });
                setProgress(2);
              }}
              onSubmitIfFree={async (data) => {
                setCartState(data);
                if (!user.user) {
                  clickOnLogin();
                  return false;
                }
                await onSubmit();
              }}
              disabled={isDisabled}
            />
          ) : (
            <Checkout
              onNextClick={onSubmit}
              disabled={isDisabled}
              cart={cartState}
              onPreviousClick={() => {
                // const params = new URLSearchParams();
                // params.set("page", "1");
                // if (id)
                //   params.set("edit", id);
                // navigate({ search: params.toString() });
                setProgress(1);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default SubmitClassified;
